export default class Menu {
    constructor(node) {
        this.node = node

        this.menuToggle = this.node.querySelector('.menu-toggle')
        this.hamburgerIcon = this.menuToggle.querySelector('.icon--hamburger')

        this.mainMenu = this.node.querySelector('.mobile-menu')
        this.prevScrollpos = window.scrollY

        if (this.mainMenu) {
            const subMenus = this.mainMenu.querySelectorAll('.sub-menu')
            subMenus.forEach(subMenu => {
                subMenu.style.display = 'none'
            })
        }

        this.trapFocus = this.trapFocus.bind(this)
        this.clickOpen = this.clickOpen.bind(this)
        this.clickClose = this.clickClose.bind(this)
        this.toggleMenu = this.toggleMenu.bind(this)
        this.handleScroll = this.handleScroll.bind(this)

        this.mainMenuItemsWithSubmenu = Array.from(
            this.mainMenu.querySelectorAll('.menu-item.has-sub-menu')
        )

        this.mainMenuItemsWithSubmenu.forEach(item => {
            const firstLink = item.querySelector('.menu-link')
            if (firstLink) {
                firstLink.setAttribute('role', 'button')
                firstLink.setAttribute('aria-expanded', 'false')
            }
        })

        this.init()
    }

    init() {
        this.reset()
        this.addListeners()
        this.initScrollListener()
    }

    addToggleListener(element, callback) {
        element.addEventListener('click', callback)
        element.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                callback(e)
            }
        })
    }

    addListeners() {
   
        this.addToggleListener(this.menuToggle, this.toggleMenu)


        this.mainMenuItemsWithSubmenu.forEach((item) => {
            const firstLink = item.querySelector('.menu-link')
            const subMenu = item.querySelector('.sub-menu')

            if (firstLink) {
                firstLink.addEventListener('click', (e) => {
                    e.preventDefault()
                    
                    const isOpen = item.classList.contains('open')
              
                    this.mainMenuItemsWithSubmenu.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('open')
                            const otherSubMenu = otherItem.querySelector('.sub-menu')
                            const otherLink = otherItem.querySelector('.menu-link')
                            if (otherSubMenu) {
                                otherSubMenu.style.display = 'none'
                            }
                            if (otherLink) {
                                otherLink.setAttribute('aria-expanded', 'false')
                            }
                        }
                    })
                    
         
                    if (isOpen) {
                        item.classList.remove('open')
                        if (subMenu) {
                            subMenu.style.display = 'none'
                        }
                        firstLink.setAttribute('aria-expanded', 'false')
                    } else {
                        item.classList.add('open')
                        if (subMenu) {
                            subMenu.style.display = 'block'
                        }
                        firstLink.setAttribute('aria-expanded', 'true')
                    }
                })
            }
        })
    }

    initScrollListener() {
        if (window.scrollY === 0) {
            this.node.classList.add('top')
        }
        
        window.addEventListener('scroll', this.handleScroll)
    }

    handleScroll() {
        const currentScrollPos = window.scrollY
        
        // Scrolling up
        if (this.prevScrollpos > currentScrollPos) {
            this.node.style.transform = 'translateY(0)'
            
            if (currentScrollPos <= 0) {
                this.node.classList.add('top')
            } else {
                this.node.classList.remove('top')
                this.node.style.transform = 'translateY(-105%)'
            }
        } 
        // Scrolling down
        else if (currentScrollPos > 0) {
            this.node.style.transform = 'translateY(-105%)'
            this.node.classList.remove('top')
        }
        
        this.prevScrollpos = currentScrollPos
    }

    toggleMenu(e) {
        e.preventDefault()
        
        const isOpen = this.node.classList.contains('menu-open')
        
        if (isOpen) {
            this.clickClose(e)
        } else {
            this.clickOpen(e)
        }
    }

    clickOpen(e) {
        e.preventDefault()

        this.node.classList.add('menu-open')
        this.mainMenu.style.display = 'flex'
        this.node.style.transform = ''

        setTimeout(() => {
            if (this.headerMenu) {
                this.headerMenu.classList.add('open')
            }
            document.querySelector('html').classList.add('h-noscroll')
            this.menuToggle.classList.add('open')
            this.hamburgerIcon.classList.add('open')
            this.mainMenu.classList.add('open')

            const onTransitionEnd = () => {
                const focusableElements = this.mainMenu.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                )
                if (focusableElements.length > 0) {
                    focusableElements[0].focus()
                }

                this.mainMenu.removeEventListener('transitionend', onTransitionEnd)
            }

            this.mainMenu.addEventListener('transitionend', onTransitionEnd)
        }, 0)

        document.addEventListener('keydown', this.trapFocus)
    }

    clickClose(e) {
        e.preventDefault()

        if (this.headerMenu) {
            this.headerMenu.classList.remove('open')
        }
        document.querySelector('html').classList.remove('h-noscroll')
        this.menuToggle.classList.remove('open')
        this.hamburgerIcon.classList.remove('open')
        this.mainMenu.classList.remove('open')
        document.removeEventListener('keydown', this.trapFocus)

        this.mainMenuItemsWithSubmenu.forEach((item) => {
            item.classList.remove('open')
            const subMenu = item.querySelector('.sub-menu')
            const firstLink = item.querySelector('.menu-link')
            if (subMenu) {
                subMenu.style.display = 'none'
            }
            if (firstLink) {
                firstLink.setAttribute('aria-expanded', 'false')
            }
        })

        setTimeout(() => {
            this.mainMenu.style.display = 'none'
            this.node.classList.remove('menu-open')
        }, 100)
    }

    trapFocus(e) {
        const focusableElements = this.mainMenu.querySelectorAll(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    e.preventDefault()
                    lastElement.focus()
                }
            } else {
                if (document.activeElement === lastElement) {
                    e.preventDefault()
                    firstElement.focus()
                }
            }
        }

        if (e.key === 'Escape') {
            this.clickClose(e)
        }
    }

    reset() {
        if (this.headerMenu) {
            this.headerMenu.classList.remove('open')
        }
        document.querySelector('html').classList.remove('h-noscroll')
        this.node.classList.remove('menu-open')
    }

    static destroy() {
        this.reset()

        this.menuToggle.removeEventListener('click', this.toggleMenu)
        window.removeEventListener('scroll', this.handleScroll)
    }

    static init() {
        const headerNode = document.querySelector('.header')
        if (!headerNode) {
            return
        }

        Menu.item = new Menu(headerNode)
    }
}